export default __webpack_public_path__ + "static/media/mercadopago.bf2fc4e8.png";